// FILE: hooks/useTopupReturn.ts
// LÀM GÌ? Khi user quay về từ app ngân hàng/PayOS (URL có ?topup=<orderCode>): kiểm tra đơn → cộng số dư → gọi onPaid (mở modal mua).
// VÌ SAO TỒN TẠI? Trên mobile user có thể thanh toán bằng app ngân hàng rồi quay lại, flow phải tiếp đúng chỗ.
// DB SCHEMA LIÊN QUAN? payment_orders
// FILE NÀO DÙNG NÓ? app/(main)/paths/[slug]/PathDetailClient.tsx, app/(main)/exams/[slug]/ExamDetailClient.tsx
"use client";

import { useEffect, useRef } from "react";
import { useDiamonds } from "@/lib/DiamondsContext";
import { verifyTopup, syncBalance } from "@/lib/wallet-client";

export function useTopupReturn(enabled: boolean, onPaid: () => void) {
  const { diamonds, addDiamonds } = useDiamonds();
  const handled = useRef(false);

  useEffect(() => {
    if (!enabled || handled.current) return;
    const url = new URL(window.location.href);
    const code = Number(url.searchParams.get("topup"));
    if (!code) return;
    handled.current = true;

    // Dọn URL (bỏ topup + các param PayOS gắn thêm) để F5 không chạy lại
    ["topup", "code", "id", "cancel", "status", "orderCode"].forEach(k => url.searchParams.delete(k));
    window.history.replaceState(null, "", url.pathname + url.search + url.hash);

    (async () => {
      // Webhook có thể đến chậm vài giây → thử tối đa 5 lần
      for (let i = 0; i < 5; i++) {
        const s = await verifyTopup(code);
        if (s === "paid") { await syncBalance(diamonds, addDiamonds); onPaid(); return; }
        if (s === "cancelled") return;
        await new Promise(r => setTimeout(r, 2000));
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
}